import FluxUtils from 'flux/utils';

import SettingsStore from 'sharedreact/stores/SettingsStore';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';

import ToolsTab from 'workspaces/launcher/components/clientapps/ToolsTab';
import ServerInfoStore from 'workspaces/launcher/stores/ServerInfoStore';
import DownloadSupport from 'workspaces/launcher/utils/DownloadSupport';
import asFunctional from 'sharedreact/components/asFunctional';

type Props = {
  index: number,
  activeTab: number
};

type State = ConstructorParameters<typeof ToolsTab>[0];

function getStores () {
  return [
    SettingsStore,
    ServerInfoStore
  ];
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  return {
    index: props.index,
    activeTab: props.activeTab,
    language: SettingsStore.getLanguage(),
    createDownloadUrl: DownloadSupport.createDownloadUrl,
    canDownloadAgent: ServerInfoStore.canDownloadAgent(),
    canDownloadPitStopEditor: ServerInfoStore.canDownloadPitStopEditor(),
    canDownloadArtProEditor: ServerInfoStore.canDownloadArtProEditor(),
    canDownloadConnectionTools: ServerInfoStore.canDownloadConnectionTools(),
    canDownloadFlexoWorkflowEditors: ServerInfoStore.canDownloadFlexoWorkflowEditors()
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(ToolsTab),
  getStores,
  calculateState,
  { withProps: true }
);
